<template>
  <div class="page-wrap">
    <person-seal></person-seal>
    <Bottom></Bottom>
  </div>
</template>
<script>
import PersonSeal from "./components/PersonSeal.vue";
import Bottom from "@/components/Bottom.vue";
import Header from "@/components/Header.vue";
export default {
  components: { PersonSeal, Bottom, Header },
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
</style>
